"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.jobCostingSchema = exports.updateTechnicianLaborRateRequestSchema = exports.technicianLaborRateResponseSchema = exports.technicianLaborRateSchema = exports.correctTimecardEntryResponseSchema = exports.correctTimecardEntryRequestSchema = exports.timecardListResponseSchema = exports.mobileSelfTimecardResponseV1Schema = exports.mobileSelfTimecardEntrySchema = exports.mobileSelfTimecardQuerySchema = exports.MOBILE_SELF_TIMECARD_CONTRACT_VERSION = exports.timecardListQuerySchema = exports.timecardEntrySchema = exports.timecardCorrectionSchema = exports.technicianPauseReasonSchema = exports.technicianTimeStopReasonSchema = exports.technicianTimeKindSchema = exports.technicianTimeEntryIdSchema = void 0;
const zod_1 = require("zod");
const pagination_1 = require("./pagination");
exports.technicianTimeEntryIdSchema = zod_1.z.string().uuid();
exports.technicianTimeKindSchema = zod_1.z.enum(["TRAVEL", "WORK"]);
exports.technicianTimeStopReasonSchema = zod_1.z.enum([
    "STARTED_WORK",
    "PAUSED",
    "COMPLETED",
    "STOPPED",
]);
exports.technicianPauseReasonSchema = zod_1.z.enum([
    "BREAK",
    "WAITING_FOR_PARTS",
    "CUSTOMER_DELAY",
    "OTHER",
]);
exports.timecardCorrectionSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    reason: zod_1.z.string().min(5).max(500),
    beforeStartedAt: zod_1.z.string().datetime(),
    beforeEndedAt: zod_1.z.string().datetime().nullable(),
    beforeLaborCostCents: zod_1.z.number().int().nonnegative(),
    afterStartedAt: zod_1.z.string().datetime(),
    afterEndedAt: zod_1.z.string().datetime(),
    afterLaborCostCents: zod_1.z.number().int().nonnegative(),
    correctedBy: zod_1.z.object({
        membershipId: zod_1.z.string().uuid(),
        displayName: zod_1.z.string().nullable(),
    }),
    correctedAt: zod_1.z.string().datetime(),
});
exports.timecardEntrySchema = zod_1.z.object({
    id: exports.technicianTimeEntryIdSchema,
    job: zod_1.z.object({
        id: zod_1.z.string().uuid(),
        jobNumber: zod_1.z.number().int().positive(),
        summary: zod_1.z.string(),
    }),
    appointmentId: zod_1.z.string().uuid(),
    technician: zod_1.z.object({
        membershipId: zod_1.z.string().uuid(),
        displayName: zod_1.z.string().nullable(),
        email: zod_1.z.string().email().nullable(),
    }),
    kind: exports.technicianTimeKindSchema,
    startedAt: zod_1.z.string().datetime(),
    endedAt: zod_1.z.string().datetime().nullable(),
    stopReason: exports.technicianTimeStopReasonSchema.nullable(),
    pauseReason: exports.technicianPauseReasonSchema.nullable(),
    pauseNote: zod_1.z.string().nullable(),
    durationSeconds: zod_1.z.number().int().nonnegative(),
    baseHourlyRateCents: zod_1.z.number().int().nonnegative(),
    laborBurdenRateMilliPercent: zod_1.z.number().int().min(0).max(100_000),
    loadedHourlyRateCents: zod_1.z.number().int().nonnegative(),
    laborCostCents: zod_1.z.number().int().nonnegative(),
    corrections: zod_1.z.array(exports.timecardCorrectionSchema),
    createdAt: zod_1.z.string().datetime(),
    updatedAt: zod_1.z.string().datetime(),
});
exports.timecardListQuerySchema = zod_1.z
    .object({
    from: zod_1.z.string().datetime(),
    to: zod_1.z.string().datetime(),
    membershipId: zod_1.z.string().uuid().optional(),
    jobId: zod_1.z.string().uuid().optional(),
    kind: exports.technicianTimeKindSchema.optional(),
    limit: zod_1.z.coerce.number().int().min(1).max(100).default(50),
    cursor: zod_1.z.string().trim().min(1).max(4_096).optional(),
})
    .superRefine(validateTimecardRange);
exports.MOBILE_SELF_TIMECARD_CONTRACT_VERSION = 1;
exports.mobileSelfTimecardQuerySchema = zod_1.z
    .object({
    from: zod_1.z.string().datetime(),
    to: zod_1.z.string().datetime(),
    kind: exports.technicianTimeKindSchema.optional(),
    limit: zod_1.z.coerce.number().int().min(1).max(100).default(50),
    cursor: zod_1.z.string().trim().min(1).max(4_096).optional(),
})
    .superRefine(validateTimecardRange);
exports.mobileSelfTimecardEntrySchema = exports.timecardEntrySchema.pick({
    id: true,
    job: true,
    appointmentId: true,
    kind: true,
    startedAt: true,
    endedAt: true,
    stopReason: true,
    pauseReason: true,
    pauseNote: true,
    durationSeconds: true,
    createdAt: true,
    updatedAt: true,
});
exports.mobileSelfTimecardResponseV1Schema = zod_1.z.object({
    contractVersion: zod_1.z.literal(exports.MOBILE_SELF_TIMECARD_CONTRACT_VERSION),
    serverNow: zod_1.z.string().datetime(),
    items: zod_1.z.array(exports.mobileSelfTimecardEntrySchema),
    totals: zod_1.z.object({
        entryCount: zod_1.z.number().int().nonnegative(),
        travelSeconds: zod_1.z.number().int().nonnegative(),
        workSeconds: zod_1.z.number().int().nonnegative(),
        trackedSeconds: zod_1.z.number().int().nonnegative(),
    }),
    pageInfo: pagination_1.pageInfoSchema.default(pagination_1.defaultPageInfo),
});
exports.timecardListResponseSchema = zod_1.z.object({
    serverNow: zod_1.z.string().datetime(),
    items: zod_1.z.array(exports.timecardEntrySchema),
    totals: zod_1.z.object({
        entryCount: zod_1.z.number().int().nonnegative(),
        travelSeconds: zod_1.z.number().int().nonnegative(),
        workSeconds: zod_1.z.number().int().nonnegative(),
        laborCostCents: zod_1.z.number().int().nonnegative(),
    }),
    pageInfo: pagination_1.pageInfoSchema.default(pagination_1.defaultPageInfo),
});
exports.correctTimecardEntryRequestSchema = zod_1.z
    .object({
    startedAt: zod_1.z.string().datetime(),
    endedAt: zod_1.z.string().datetime(),
    reason: zod_1.z.string().trim().min(5).max(500),
})
    .refine((value) => Date.parse(value.endedAt) > Date.parse(value.startedAt), {
    path: ["endedAt"],
    message: "End time must be after start time.",
});
exports.correctTimecardEntryResponseSchema = zod_1.z.object({
    entry: exports.timecardEntrySchema,
    correction: exports.timecardCorrectionSchema,
});
exports.technicianLaborRateSchema = zod_1.z.object({
    membershipId: zod_1.z.string().uuid(),
    baseHourlyRateCents: zod_1.z.number().int().nonnegative(),
    laborBurdenRateMilliPercent: zod_1.z.number().int().min(0).max(100_000),
    loadedHourlyRateCents: zod_1.z.number().int().nonnegative(),
    effectiveAt: zod_1.z.string().datetime(),
    updatedByMembershipId: zod_1.z.string().uuid(),
});
exports.technicianLaborRateResponseSchema = exports.technicianLaborRateSchema.nullable();
exports.updateTechnicianLaborRateRequestSchema = zod_1.z.object({
    baseHourlyRateCents: zod_1.z.number().int().min(0).max(10_000_000),
    laborBurdenRateMilliPercent: zod_1.z.number().int().min(0).max(100_000),
});
exports.jobCostingSchema = zod_1.z.object({
    jobId: zod_1.z.string().uuid(),
    jobNumber: zod_1.z.number().int().positive(),
    currency: zod_1.z.literal("USD"),
    revenueCents: zod_1.z.number().int().nonnegative(),
    laborCostCents: zod_1.z.number().int().nonnegative(),
    materialCostCents: zod_1.z.number().int().nonnegative(),
    otherDirectCostCents: zod_1.z.number().int().nonnegative(),
    totalCostCents: zod_1.z.number().int().nonnegative(),
    grossProfitCents: zod_1.z.number().int(),
    grossMarginBasisPoints: zod_1.z.number().int().nullable(),
    uncostedLineCount: zod_1.z.number().int().nonnegative(),
    labor: zod_1.z.array(zod_1.z.object({
        membershipId: zod_1.z.string().uuid(),
        technicianName: zod_1.z.string().nullable(),
        durationSeconds: zod_1.z.number().int().nonnegative(),
        laborCostCents: zod_1.z.number().int().nonnegative(),
    })),
    calculatedAt: zod_1.z.string().datetime(),
});
function validateTimecardRange(value, context) {
    const from = Date.parse(value.from);
    const to = Date.parse(value.to);
    if (to <= from) {
        context.addIssue({
            code: "custom",
            path: ["to"],
            message: "The end of the range must be after the start.",
        });
        return;
    }
    if (to - from > 93 * 24 * 60 * 60 * 1_000) {
        context.addIssue({
            code: "custom",
            path: ["to"],
            message: "Timecard ranges cannot exceed 93 days.",
        });
    }
}
//# sourceMappingURL=timecard.js.map